<template>
  <img v-if="lazy" :defaultimg="lazyImage" :datalazy="imageSrc" :width="imageWidth" :height="imageHeight" :style="{'border-radius': `${radius || 0}px`}" />
  <img v-else-if="!lazy && imageLoad" :src="imageSrc" :width="imageWidth" :height="imageHeight" :style="{'border-radius': `${radius || 0}px`}" />

</template>


<script>
  import { ensure_protocol } from '@beastshop/url-util'
  import * as util from './lib/util.js'

  export default {
    name: 'beast-image',
    props: {
      src: {
        type: String,
        default: '',
      },
      image: {
        type: Object,
        default: null
      },
      containerWidth: {
        type: Number,
        default: 0,
      },
      clipData: [String, Object],
      lazy: {
        type: Boolean,
        default: false
      },
      defaultImage: {
        type: String,
        default: ''
      },
      timeout: {
        type: Number,
        default: 100
      },
      load: {
        type: Boolean,
        default: true
      },
      suffix: {
        type: String,
        default: "",
      },
      fixWidth: {
        type: Number,
        default: 0
      },
      radius: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        imageLoad: false,
        imageData: {},
        imageSrc: null,
        imageWidth: "",
        imageHeight: "",
        lazyImage: null
      }
    },
    computed: {
      // imgSrc () {
      //   return ensure_protocol(this.src)
      // }
    },
    watch: {
      src: function () {
        this.$nextTick (() => {
          // console.log(this.src, "watch src")
          this.transform()
        })
      },
      image: function () {
        this.$nextTick (() => {
          // console.log(this.image, "watch image")
          this.transform()
        })
      }
    },
    created () {
      this.transform()
    },
    methods: {
      transform () {
        if(!this.src && !this.image) {
          return
        }
        let formatData = util.transform({
          data: this.src || this.image,
          containerWidth: this.containerWidth,
          clipData: this.clipData,
          suffix: this.suffix,
          fixWidth: this.fixWidth
        })
        formatData.src = ensure_protocol(formatData.src)
        // console.log(formatData)
        if(this.lazy) {
          this.imageData = formatData
          this.imageSrc = this.imageData.src
          this.imageWidth = this.imageData.width
          this.imageHeight = this.imageData.height
          // console.log(this.defaultImage, "defaultImage")
          if(this.defaultImage) {
            this.lazyImage = ensure_protocol(this.defaultImage)
          }
        } else {
          let dataFlag = true
          this.getImage(formatData, dataFlag)
        }
      },
      getImage (formatImage, dataFlag) {
        // console.log("getImage")
        // console.log(formatImage)
        if(!this.load) {
          this.imageData = formatImage
          this.setImage()
          this.imageLoad = true
          return
        }
        let tm = setTimeout(() => {
          // console.log("timeout")
          if(dataFlag) {
            this.imageData = formatImage
            this.setImage()
            // this.imageSrc = this.imageData.src
            // this.imageWidth = this.imageData.width
            // this.imageHeight = this.imageData.height
          }
          this.imageLoad = true
        }, this.timeout)
        this.loadImage (formatImage.src, (err, imgObj) => {
          if (this.imageLoad) {
            return
          } else {
            clearTimeout(tm)
          }
          let src = formatImage.src
          if(err || !imgObj) {
            return
            // src = imgObj.src
          }
          if(dataFlag) {
            this.imageData = {
              src: imgObj.src,
              width: formatImage.width,
              height: formatImage.height
            }
            this.setImage()
            // this.imageSrc = this.imageData.src
            // this.imageWidth = this.imageData.width
            // this.imageHeight = this.imageData.height
          }
          this.imageLoad = true
        })
      },
      setImage () {
        this.imageSrc = this.imageData.src
        this.imageWidth = this.imageData.width
        this.imageHeight = this.imageData.height
      },
      loadImage (src, callback) {
        // console.log("loadImage")
        const image = new Image()
        let doned

        function done (err) {
          if (doned) {
            return
          }
          doned = true
          image.onload = image.onerror = image.onabort = null

          if (err) {
            return callback(err)
          }

          const {
            height,
            width,
            src
          } = image
          callback(null, {
            height,
            width,
            src
          })
        }

        image.onload = () => {
          done()
        }

        image.onabort = () => {
          done('abort')
        }

        image.onerror = () => {
          done('error')
        }

        image.src = src
      }


    },
  }
</script>

<style lang="stylus">
  img
    width 100%
    overflow hidden
    &.lazy-fadeIn
      animation lazy-fade-in 400ms

  @keyframes lazy-fade-in {
    from {
      opacity: 0
    }
    to {
      opacity: 1
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?11305482